import React, { useMemo } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import SuccessIcon from '@material-ui/icons/Check';
import ErrorIcon from '@material-ui/icons/Error';
import classNames from 'classnames';
import { ILoadingBackdropProps } from './types';
import style from './style.module.css';

const NS = 'LoadingBackdrop';

export default function LoadingBackdrop(props: ILoadingBackdropProps) {
  const {
    status,
    loadingText = 'Loading',
    failedText = 'Error',
    successText = 'Success',
  } = props;

  const icon = useMemo(() => {
    let icon = null;

    if (status === 'LOADING') {
      icon = <CircularProgress size={45} />
    }

    if (status === 'SUCCESS') {
      icon = <SuccessIcon data-testid="success-icon" fontSize="large" />
    }

    if (status === 'FAILED') {
      icon =  <ErrorIcon data-testid="failed-icon" fontSize="large" />
    }

    return (
      <div className={style.icon}>
        {icon}
      </div>
    )
  }, [status])

  const text = useMemo(() => {
    let text = ''

    if (status === 'LOADING') {
      text = loadingText
    }

    if (status === 'SUCCESS') {
      text = successText;
    }

    if (status === 'FAILED') {
      text = failedText
    }

    return (
      <div className={classNames({
        [style.content]: true,
        [style.contentLoading]: status === 'LOADING'
      })}>
        {text}
      </div>
    )
  }, [
    status,
    loadingText,
    failedText,
    successText
  ])

  if (status === 'IDLE' || status === 'LOADED') return null;

  return (
    <div className={style.root} data-testid="container">
      <div className={style.contentWrapper}>
        {icon}
        {text}
      </div>
    </div>
  )
}
